<template>
  <div>
    <Head :title="__('user.create')" />
    <h1 class="h1">
      <Link class="text-primary-400 hover:text-primary-600" href="/users">{{ __('user.singular') }}</Link>
      <span class="text-primary-400 font-medium">/ {{ __('general.create') }}</span>
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap md:-mb-8 md:-mr-6 p-5 md:p-8 text-sm md:text-base">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2" :label="__('general.firstname')" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2" :label="__('general.lastname')" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2" :label="__('general.email')" />
          <text-input v-model="form.password" :error="form.errors.password" class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2" type="password" autocomplete="new-password" :label="__('general.password')" />
          <div class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2">
            <div class="">
              <label for="text_answer" class="block mb-2 text-sm font-medium text-gray-900">
                Campus User?
              </label>
              <label for="campus" class="inline-flex relative items-center cursor-pointer">
                <input v-model="form.is_campus" id="campus" type="checkbox" class="sr-only peer">
                <div :class="toggleCampusClass"
                     class=" w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"
                ></div>
                <span class="ml-3 text-sm font-medium text-gray-900">{{ __('general.' + form.is_campus) }}</span>
              </label>
            </div>
            <div>
              <label for="text_answer" class="block mb-2 text-sm font-medium text-gray-900">
                BV Mitglied?
              </label>
              <label for="member" class="inline-flex relative items-center cursor-pointer">
                <input v-model="form.is_member" type="checkbox" id="member" class="sr-only peer">
                <div :class="toggleMemberClass"
                     class=" w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"
                ></div>
                <span class="ml-3 text-sm font-medium text-gray-900">{{ __('general.' + form.is_member) }}</span>
              </label>
            </div>
          </div>
          <file-input v-model="form.photo" :error="form.errors.photo" class="pb-4 pr-4 md:pb-8 md:pr-6 w-full lg:w-1/2" type="file" accept="image/*" :label="__('general.photo')" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-primary" type="submit">{{ __('user.create') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        owner: false,
        photo: null,
        is_campus: false,
        is_member: false,
      }),
    }
  },

  computed: {
    toggleMemberClass: function() {
      return ( this.form.is_member ) ? 'bg-secondary-500' : 'bg-gray-200'
    },
    toggleCampusClass: function() {
      return ( this.form.is_campus ) ? 'bg-secondary-500' : 'bg-gray-200'
    },
  },

  methods: {
    store() {
      this.form.post('/users')
    },
  },
}
</script>
